import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// import activitiesdetails from '../../images/activities-details.png';
import activitiesdetails from "../../images/activitiesdetailarrow.svg";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import mixpanel from "mixpanel-browser";
import "../DashboardHeader.css";
// import './DashboardHeader.css';
// import './recommandedactivity.css';
import "./explorecard.css";
import Cookies from "universal-cookie";

const DashboardExploreCards = (props) => {
  const navigate = useNavigate();
  const [openNewsPodcastModal, setOpenNewsPodcastModal] = useState(false);
  const [openChatBotModal, setOpenChatBotModal] = useState(false);
  const cookies = new Cookies();
  const isLoggedIn = cookies.get("isLoggedIn", { path: "/" });


  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "2px solid transparent",
    borderRadius: "12px",
    bgcolor: "#f8f8f8",
    boxShadow: " 0px 4px 34px 0px #00000040",
    width: { xs: "95%", md: 600, lg: 700 },
    outline: "none",
  };

  const style1 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "2px solid transparent",
    borderRadius: "12px",
    bgcolor: "#f8f8f8",
    boxShadow: " 0px 4px 34px 0px #00000040",
    width: { xs: "95%", md: 600, lg: 600 },
    outline: "none",
  };

  const handleButtonClick = (link, heading, id) => {
    if (link && link.includes("https")) {
      window.open(link, "_blank");
    } else {
      mixpanel.track(`${heading} navigation`, {});
      if (id === "3") {
        setOpenNewsPodcastModal(true);
        // window.open(link, '_blank');
        // window.location.href = link;
      } else if (id === "7") {
        setOpenChatBotModal(true);
      } else {
        navigate(link);
      }
    }
  };

  // const handleSecButtonClick = (link1, buttonName1) => {
  //   if (buttonName1 === 'Listen Now') {
  //     window.open(link1, '_blank');
  //   }
  // };

  return (
    <>
      {/* news and podcast join modal */}
      <Modal
        open={openNewsPodcastModal}
        onClose={() => {
          setOpenNewsPodcastModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="fitbit-modal"
      >
        <Box sx={style}>
          <div className="p-4">
            <div className="d-flex justify-content-end">
              <button
                style={{
                  background: "transparent",
                  fontWeight: "600",
                  border: "none",
                  outline: "none",
                  fontSize: "22px",
                }}
                onClick={() => {
                  setOpenNewsPodcastModal(false);
                }}
              >
                X
              </button>
            </div>
            <div className="d-flex flex-column align-items-center">
              <h6 className="explore_newsletter_popup">
                Explore our Happiness Newsletter or listen to our podcast
              </h6>
              <button
                className="d-flex flex-column align-items-center btn buy--near--btn mb-3"
                onClick={() => {
                  window.open(
                    "https://bithappier-newsletter.beehiiv.com/",
                    "_blank"
                  );
                  setOpenNewsPodcastModal(false);
                }}
              >
                Join Our Newsletter
              </button>
              <button
                className="d-flex flex-column align-items-center btn buy--near--btn mb-4"
                onClick={() => {
                  // window.open(
                  //   "https://promocards.byspotify.com/api/share/cfb72777-d462-4368-a141-8dbb4a8c99ed",
                  //   "_blank"
                  // );
                  setOpenNewsPodcastModal(false);
                  navigate('/happinesscontent')
                }}
              >
                Happiness Space <br />
                {/* <span>(Only on Spotify)</span> */}
              </button>
              {/* <button
                className="d-flex flex-column align-items-center btn buy--near--btn mb-4"
                onClick={() => {
                  window.open("https://www.youtube.com/@bithappier", "_blank");
                  setOpenNewsPodcastModal(false);
                }}
              >
                Watch Video on YouTube
              </button> */}
            </div>
          </div>
        </Box>
      </Modal>

      {/* chatbot modal */}
      <Modal
        open={openChatBotModal}
        onClose={() => {
          setOpenChatBotModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="fitbit-modal"
      >
        <Box sx={style1}>
          <div className="p-4">
            <div className="d-flex justify-content-end">
              <button
                style={{
                  background: "transparent",
                  fontWeight: "600",
                  border: "none",
                  outline: "none",
                  fontSize: "22px",
                }}
                onClick={() => {
                  setOpenChatBotModal(false);
                }}
              >
                X
              </button>
            </div>
            <div className="d-flex flex-column align-items-center">
              <h6 className="explore_newsletter_popup chatbot_popup_heading">
                Explore our Happiness Chatbot
              </h6>
              <button
                className="d-flex flex-column align-items-center btn buy--near--btn mb-3"
                onClick={() => {
                  navigate("/cbthelp");
                  setOpenNewsPodcastModal(false);
                }}
              >
                CBT Articles
                <span>
                  (Our Researched Information for the Cognitive Guidance)
                </span>
              </button>
              <button
                className="d-flex flex-column align-items-center btn buy--near--btn mb-4"
                onClick={() => {
                  navigate("/selfhelp");
                  setOpenNewsPodcastModal(false);
                }}
              >
                Happiness Buddy
                <span>(Our AI-based Happiness Chatbot.)</span>
              </button>
            </div>
          </div>
        </Box>
      </Modal>

      <div
        style={{ background: "#FFFFFF", borderRadius: "12px" }}
        className="explore--activities p-4 d-flex flex-column"
      >
        <div className="explore-img-div flex-column">
          <img
            src={props.image}
            alt=""
            srcSet=""
            className="explore--activities--img"
            style={{ height: '80px' }}
          />
          {/* <span className="explorecard--heading">{props.heading}</span> */}
        </div>
        <div className="explore--heading-div">
          <span className="explorecard--heading">{props.heading}</span>
        </div>
        <div className="d-flex flex-row justify-content-start align-items-start">
          <div className="d-flex flex-row justify-content-end align-items-center button_div">
            {/* <Link to={props.link}> */}
            <p
              className=""
              style={{ color: isLoggedIn ? '#0c4e7e' : '#d9567a', textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() =>
                handleButtonClick(props.link, props.heading, props.id)
              }
            >
              <span className="">
                {props.buttonName}
              </span>
              {/* <img
                style={{ height: "10px", fontWeight: "700" }}
                src={activitiesdetails}
                alt=""
                srcSet=""
              /> */}
            </p>
            {/* </Link> */}
            {/* {props.buttonName1 && (
            <Link to={props.link1} className="sec_know_more">
              <span
                className="explore_link_backcolor"
                // onClick={() =>
                //   handleSecButtonClick(props.link1, props.buttonName1)
                // }
              >
                <span className="explore--know--more--txt">
                  {props.buttonName1}
                </span>
                <img
                  src={activitiesdetails}
                  alt=""
                  style={{ height: '10px', fontWeight: '700' }}
                />
              </span>
            </Link>
          )} */}
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardExploreCards;
